/**
 * @returns {Object}
 */
export function limitToMax() {
    
    return {
        restrict: 'A',
        require: 'ngModel',
        
        link: ($scope, $element, attr, ngModelCtrl) => {
            
            let max = Number(attr.limitToMax) || 99;
            
            ngModelCtrl.$parsers.push((value) => {
                
                if (Number(value) > max) {
                    
                    value = max;
                    
                    $element.val(value);
                }
                
                return value;
            });
            
            attr.$observe('limitToMax', (value) => {
                
                max = value;
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/limit-to-max.directive.js